import styled, { keyframes } from 'styled-components';
import { Box } from '../Box/index.js';
import { responsiveProperty } from '../../utils/responsiveProperty/responsiveProperty.js';
import { themeGet, themeGetColor } from '../theme/themeGet/get.js';

var backgroundAnimation = keyframes(["0%{background-position:0% 50%;}50%{background-position:100% 50%;}100%{background-position:0% 50%;}"]);
var getAppearanceColors = function getAppearanceColors(appearance) {
  switch (appearance) {
    case 'purple':
      return {
        color1: themeGetColor('purple.50'),
        color2: themeGetColor('purple.200')
      };
    case 'gray':
      return {
        color1: themeGetColor('gray.50'),
        color2: themeGetColor('gray.200')
      };
    default:
      return {
        color1: themeGetColor('gray.50'),
        color2: themeGetColor('gray.200')
      };
  }
};
var SkeletonBox = styled(Box).withConfig({
  displayName: "SkeletonBox",
  componentId: "sc-72fi6g-0"
})(["", ";", ";", ";background:", ";background-size:400% 400%;animation:", " 3s ease infinite;border:none;box-shadow:none;box-decoration-break:clone;color:transparent;outline:none;pointer-events:none;user-select:none;cursor:default;& > *,&::after,&::before{visibility:hidden;}"], function (props) {
  return props.height && responsiveProperty('height', props.height);
}, function (props) {
  return props.width && responsiveProperty('width', props.width);
}, function (props) {
  return responsiveProperty('borderRadius', props.borderRadius || themeGet('borderRadius.md'));
}, function (props) {
  var colors = getAppearanceColors(props.appearance);
  return "linear-gradient(\n      -45deg,\n      " + colors.color1 + ",\n      " + colors.color2 + ",\n      " + colors.color1 + ",\n      " + colors.color2 + "\n    )";
}, backgroundAnimation);

export { SkeletonBox };
